import { errorInput } from 'src/components/helpers';
import {
  isValidBirthdate,
  isValidEmail,
  isValidIdentification,
  isValidPhone,
} from 'src/components/helpers/guests/guestFieldValidation';

const BASE_FIELDS = ['name', 'lastName', 'identification', 'phone', 'birthdate', 'gender', 'civil'];

const FULL_FORM_FIELDS = [...BASE_FIELDS, 'preferredContact', 'interestedGroup'];

const markInvalid = (errorInputs, name, valid) =>
  valid
    ? errorInputs
    : errorInput({
        errorInputs,
        input: { name, value: false },
      });

export const validateNewMembersForm = (Attendant, { alreadySubmitted = false } = {}) => {
  let nextErrorInputs = {};
  const fields = alreadySubmitted ? BASE_FIELDS : FULL_FORM_FIELDS;

  fields.forEach((input) => {
    nextErrorInputs = errorInput({
      errorInputs: nextErrorInputs,
      input: { name: input, value: Attendant[input] },
    });
  });

  nextErrorInputs = markInvalid(
    nextErrorInputs,
    'identification',
    isValidIdentification(Attendant.identification)
  );
  nextErrorInputs = markInvalid(nextErrorInputs, 'phone', isValidPhone(Attendant.phone));
  nextErrorInputs = markInvalid(
    nextErrorInputs,
    'birthdate',
    isValidBirthdate(Attendant.birthdate, { required: true })
  );

  if (Attendant.email) {
    nextErrorInputs = markInvalid(nextErrorInputs, 'email', isValidEmail(Attendant.email));
  }

  if (!alreadySubmitted) {
    nextErrorInputs = errorInput({
      errorInputs: nextErrorInputs,
      input: { name: 'habeasDataAccepted', value: Attendant.habeasDataAccepted },
    });
  }

  return nextErrorInputs;
};
